import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./TravelRuleLogin.css";
import { showToast } from "../../CoreDataService";
import { useSelector } from "react-redux";

const TravelRuleRecipientInfo = ({ data }) => {
  const { brokerDetailedInfo } = useSelector((state) => state);
  const [userTravelData, setUserTravelData] = useState(null);
  const [validName, setValidName] = useState("2");
  const [validAccount, setValidAccount] = useState("2");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // First, try to get data from navigation state
    if (location.state && location.state.userTravelData) {
      const receivedData = location.state.userTravelData;
      setUserTravelData(receivedData);
      console.log("Data received from navigation:", receivedData);

      // Also store in localStorage as backup
      localStorage.setItem("userTravelData", JSON.stringify(receivedData));
    }
    // Fallback: try to get from localStorage
    else {
      const storedData = localStorage.getItem("userTravelData");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setUserTravelData(parsedData);
        console.log("Data loaded from localStorage:", parsedData);
      } else {
        // Redirect to login if no data found
        console.log("No data found, redirecting to login");
        navigate("/travel-rule-authentication");
      }
    }
  }, [location, navigate]);

  // Method to save travel rule data
  const saveTravelRuleData = async () => {
    if (!userTravelData) return;

    console.log("iiiiiiii", userTravelData);

    const payload = {
      validName: validName,
      validAccount: validAccount,
      adminUser: userTravelData.username,
    };

    if (userTravelData.uniqueId !== null) {
      payload.validUniqueId = validAccount;
    }

    try {
      const response = await fetch(
        "https://accounts.paybito.com/api/home/storeVerifierResponse",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg); // Error message
      } else {
        showToast("success", result.error.error_msg); // Success message
      }
    } catch (error) {
      console.error("Error saving travel rule data:", error);
      alert("An error occurred while saving. Please try again.");
    }
  };

  // Helper functions to determine what to display
  const isIndividual = userTravelData?.accountType === 1;
  const showUniqueIdSection = userTravelData?.uniqueId !== null;

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  // Dynamic styles
  // Dynamic styles
  const bodyStyle = {
    background: frontPagebakgColor,
    minHeight: "100vh",
    margin: "0px !important",
  };
  const navStyle = data?.styleOne
    ? { background: data.backgroundNavColorDynamic, height: "60px" }
    : { backgroundColor: "blue", height: "60px" };

  if (!userTravelData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bitrump-body paybito-bitrump" style={bodyStyle}>
      {/* Navbar */}

      <div className="container">
        <div className="mx-auto mt-5">
          <div className="card-header text-center text-blue p-0"></div>

          <h5
            className="py-3"
            style={{
              textAlign: "center",
              fontSize: "45px",
              paddingTop: "0px !important",
              color: "#fff",
            }}
          >
            Travel Rule Recipient Info
          </h5>

          <div
            className="card-body p-3 card-login-body"
            style={{ color: "black", backgroundColor: "white" }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="my-5">
                  <div className="terms-use-wrap">
                    <div className="p-1">
                      <p>
                        Compliance Requirement: Travel Rule Recipient Info:
                        Validation required at your end.
                      </p>
                      <p>
                        You have been identified as the recipient crypto firm by
                        our user. The crypto transfer is going from our firm to
                        yours. We are required by regulators to send you this
                        information for your validation and record keeping.
                      </p>
                      <p>
                        <b>
                          Information of the Recipient crypto firm (you) as
                          provided by User for your validation
                        </b>
                      </p>
                      <p>
                        Recipient entity selected :{" "}
                        {isIndividual ? "Individual" : "Company"}
                      </p>
                      {/* <p id="userType">
                        
                      </p> */}

                      <div className="outer_list">
                        <p> Name of recipient entity : {userTravelData.name}</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validName"
                              value="2"
                              checked={validName === "2"}
                              onChange={(e) => setValidName(e.target.value)}
                            />{" "}
                            This info is false
                          </div>

                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validName"
                              value="1"
                              checked={validName === "1"}
                              onChange={(e) => setValidName(e.target.value)}
                            />{" "}
                            We confirm that this info is true
                          </div>
                        </div>
                      </div>
                      <br />

                      <p>
                        What is the account number or their customer number or
                        unique identifier of the recipient in the exchange or
                        wallet you are making the transfer to? (If you do not
                        know this, ask the recipient to provide you with this
                        info).
                      </p>
                      <div className="outer_list">
                        <p>Account No :{userTravelData.accountId}</p>

                        {showUniqueIdSection && (
                          <p> Unique Id :{userTravelData.uniqueId}</p>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validAccount"
                              value="2"
                              checked={validAccount === "2"}
                              onChange={(e) => setValidAccount(e.target.value)}
                            />{" "}
                            This info is false
                          </div>
                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validAccount"
                              value="1"
                              checked={validAccount === "1"}
                              onChange={(e) => setValidAccount(e.target.value)}
                            />{" "}
                            We confirm that this info is true
                          </div>
                        </div>
                      </div>

                      <div className="outer_list">
                        <button
                          style={{ width: "20%" }}
                          className="btn btn-primary mt-3"
                          id="submitBtn"
                          onClick={saveTravelRuleData}
                        >
                          Submit
                        </button>
                      </div>
                      <br />

                      {/* <p>Thank you for validating the information.</p>
                      <p>Sincerely,</p>
                      <p>{data?.exchange || "Exchange"}</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelRuleRecipientInfo;
